import React from 'react';
import {MasterLayout} from 'layout';
import {CanBoNhanKetQuaKiemTraDeXuat} from 'modules/reception';

export default class KetQuaCanBoNhanKetQuaKiemTraDeXuatPage extends React.Component {
  
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
         <CanBoNhanKetQuaKiemTraDeXuat params={this.props.params} viewOnly={true}/>
      </MasterLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/reception/KetQuaCanBoNhanKetQuaKiemTraDeXuatPage.jsx